var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50.0 50.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1643 L0,1643 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C38.8071187,-2.53632657e-15 50,11.1928813 50,25 C50,38.8071187 38.8071187,50 25,50 C11.1928813,50 1.69088438e-15,38.8071187 0,25 C-1.69088438e-15,11.1928813 11.1928813,2.53632657e-15 25,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.71,0.231953436 C16.12,-0.148046564 16.82,-0.0180465644 17.18,0.311953436 L22.55,6.01195344 C22.71,6.18195344 22.81,6.46195344 22.82,6.70195344 C22.82,6.97195344 22.73,7.19195344 22.55,7.41195344 L17.18,13.1119534 C16.83,13.4519534 16.11,13.5719534 15.71,13.1919534 C15.31,12.8119534 15.38,12.0619534 15.72,11.7219534 L19.49,7.72195344 L1.01,7.72195344 C0.45,7.72195344 0,7.27195344 0,6.71195344 C0,6.15195344 0.45,5.70195344 1.01,5.70195344 L19.49,5.70195344 L15.72,1.70195344 C15.32,1.32195344 15.31,0.601953436 15.71,0.231953436 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-327.0 -146.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.0 146.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 50,0 50,50 0,50 0,0",
    stroke: "none",
    fill: "#AEAEAE",
    opacity: "25.1306443%"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.81999999999988 18.000000000000682) scale(-1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-5.23470156e-14 22.82,-5.23470156e-14 22.82,13.4270716 0,13.4270716 0,-5.23470156e-14",
    stroke: "none",
    fill: "#013B93"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.2789409f8c6f78bb0e0c67a1b9b9f1a7.svg";
export { ForwardRef as ReactComponent };